<div
  class="max-w-6xl mx-auto py-12 px-6 flex flex-col items-center animate-in fade-in slide-in-from-right-4 duration-700"
>
  <header class="text-center mb-20 max-w-3xl">
    <h1 class="text-4xl font-extrabold text-gray-12 sm:text-6xl mb-6 tracking-tight">
      Vendez aux meilleures conditions avec <span class="text-primary font-black">Etxe</span>
    </h1>
    <p class="text-xl text-gray-11 max-w-2xl mx-auto leading-relaxed">
      Comparez les propositions des meilleurs agents de votre secteur et choisissez le partenaire idéal pour
      votre vente.
    </p>
  </header>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-16 mb-24 relative">
    <div
      class="hidden md:block absolute top-18 left-[20%] right-[20%] h-0.5 bg-gradient-to-r from-indigo-a2 via-indigo-a4 to-indigo-a2 -z-10"
    ></div>

    <!-- Step 1 -->
    <div class="flex flex-col items-center text-center group">
      <div
        class="w-36 h-36 rounded-full bg-gray-1 border-2 border-gray-6 flex items-center justify-center text-primary mb-10 shadow-soft group-hover:border-primary group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 relative"
      >
        <div
          class="absolute -top-4 -right-4 w-12 h-12 bg-primary text-white flex items-center justify-center rounded-2xl text-2xl font-black shadow-lg"
        >
          1
        </div>
        <img
          src="assets/property-creation/step_details.png"
          alt="Description du logement"
          class="w-full h-full object-cover rounded-full opacity-90 group-hover:opacity-100 transition-opacity"
        />
      </div>
      <h3 class="text-2xl font-bold text-gray-12 mb-4 group-hover:text-primary transition-colors">
        Décrivez votre bien
      </h3>
      <p class="text-gray-11 leading-relaxed">
        Renseignez les caractéristiques clés de votre logement (surface, localisation, photos, DPE) grâce à
        notre formulaire guidé pas-à-pas.
      </p>
    </div>

    <!-- Step 2 -->
    <div class="flex flex-col items-center text-center group pointer-events-auto">
      <div
        class="w-36 h-36 rounded-full bg-gray-1 border-2 border-gray-6 flex items-center justify-center text-primary mb-10 shadow-soft group-hover:border-primary group-hover:-rotate-3 group-hover:scale-110 transition-all duration-500 relative"
      >
        <div
          class="absolute -top-4 -right-4 w-12 h-12 bg-primary text-white flex items-center justify-center rounded-2xl text-2xl font-black shadow-lg"
        >
          2
        </div>
        <img
          src="assets/property-creation/step_publish.png"
          alt="Définissez votre cadre"
          class="w-full h-full object-cover rounded-full opacity-90 group-hover:opacity-100 transition-opacity"
        />
      </div>
      <h3 class="text-2xl font-bold text-gray-12 mb-4 group-hover:text-primary transition-colors">
        Définissez votre cadre
      </h3>
      <p class="text-gray-11 leading-relaxed">
        Précisez vos attentes : type de mandat envisagé, objectifs de prix et honoraires cibles. Vous gardez
        la maîtrise de votre projet.
      </p>
    </div>

    <!-- Step 3 -->
    <div class="flex flex-col items-center text-center group">
      <div
        class="w-36 h-36 rounded-full bg-gray-1 border-2 border-gray-6 flex items-center justify-center text-primary mb-10 shadow-soft group-hover:border-primary group-hover:rotate-3 group-hover:scale-110 transition-all duration-500 relative"
      >
        <div
          class="absolute -top-4 -right-4 w-12 h-12 bg-primary text-white flex items-center justify-center rounded-2xl text-2xl font-black shadow-lg"
        >
          3
        </div>
        <img
          src="assets/property-creation/step_validate.png"
          alt="Sélectionnez votre agent"
          class="w-full h-full object-cover rounded-full opacity-90 group-hover:opacity-100 transition-opacity"
        />
      </div>
      <h3 class="text-2xl font-bold text-gray-12 mb-4 group-hover:text-primary transition-colors">
        Comparez et choisissez
      </h3>
      <p class="text-gray-11 leading-relaxed">
        Recevez les candidatures et stratégies d'agents certifiés (Carte T vérifiée), comparez leurs approches
        et sélectionnez votre professionnel en toute sérénité.
      </p>
    </div>
  </div>

  <div class="flex flex-col items-center gap-6">
    <button
      mat-flat-button
      class="primary px-20! py-10! text-3xl! shadow-2xl hover:shadow-indigo-a6 hover:scale-[1.02] active:scale-95 transition-all duration-300"
      (click)="startClicked.emit()"
    >
      Commencer la création
      <mat-icon class="ml-4 scale-150">bolt</mat-icon>
    </button>
    <button
      mat-button
      class="text-gray-10 hover:text-gray-12 font-bold tracking-widest text-xs uppercase"
      (click)="backClicked.emit()"
    >
      Retour à mes annonces
    </button>
  </div>
</div>
